module.exports = __webpack_public_path__ + "img/teddi-white.801c0295.svg";